import {
  useGetCustomer,
  useGetCustomerTribe,
  useGetDetailTribe,
} from "@/services/api";

export const useFWBMemberStatus = () => {
  const { data: customer } = useGetCustomer();
  const { data: customerTribe, isLoading: isTribeLoading } =
    useGetCustomerTribe();
  const tribeId = customerTribe?.tribeId ?? "";
  const { data: tribeDetail, isLoading: isDetailLoading } = useGetDetailTribe(
    tribeId,
    {
      query: { enabled: !!tribeId },
    },
  );

  const currentMember = tribeDetail?.memberInfo?.find(
    (member) =>
      member.userId !== undefined &&
      String(member.userId) === String(customer?.customerId),
  );
  const inactiveDays = currentMember?.inactiveDays ?? 0;
  const isAtRiskOfRemoval = !!tribeId && inactiveDays > 0;

  return {
    isAtRiskOfRemoval,
    inactiveDays,
    tribeDiscount: tribeDetail?.tribeDiscountNext ?? 0,
    isLoading: isTribeLoading || (!!tribeId && isDetailLoading),
  };
};
